/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AdminActionResponse,
  AdminScope,
  PaginatedUserManagementListList,
  PatchedUserManagementEditRequest,
  RoleChangeRequest,
  UserManagementDetail,
  UserManagementEdit,
  UserManagementInviteError,
  UserManagementInviteRequest,
  UserManagementInviteSuccess,
  UserManagementListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type userManagementListResponse200 = {
  data: PaginatedUserManagementListList
  status: 200
}

export type userManagementListResponseSuccess = (userManagementListResponse200) & {
  headers: Headers;
};
;

export type userManagementListResponse = (userManagementListResponseSuccess)

export const getUserManagementListUrl = (params?: UserManagementListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["role"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/user-management/?${stringifiedParams}` : `/api/v1/user-management/`
}

/**
 * GET /user-management/ — List users in scope (paginated, filterable).
 */
export const userManagementList = async (params?: UserManagementListParams, options?: RequestInit): Promise<userManagementListResponse> => {

  return customFetch<userManagementListResponse>(getUserManagementListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type userManagementRetrieveResponse200 = {
  data: UserManagementDetail
  status: 200
}

export type userManagementRetrieveResponseSuccess = (userManagementRetrieveResponse200) & {
  headers: Headers;
};
;

export type userManagementRetrieveResponse = (userManagementRetrieveResponseSuccess)

export const getUserManagementRetrieveUrl = (id: string,) => {




  return `/api/v1/user-management/${id}/`
}

/**
 * GET /user-management/{id}/ — User detail with available accounts.
 */
export const userManagementRetrieve = async (id: string, options?: RequestInit): Promise<userManagementRetrieveResponse> => {

  return customFetch<userManagementRetrieveResponse>(getUserManagementRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type userManagementPartialUpdateResponse200 = {
  data: UserManagementEdit
  status: 200
}

export type userManagementPartialUpdateResponseSuccess = (userManagementPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type userManagementPartialUpdateResponse = (userManagementPartialUpdateResponseSuccess)

export const getUserManagementPartialUpdateUrl = (id: string,) => {




  return `/api/v1/user-management/${id}/`
}

/**
 * PATCH /user-management/{id}/ — Edit user details, customer accounts, and optionally change role.
 */
export const userManagementPartialUpdate = async (id: string,
    patchedUserManagementEditRequest?: PatchedUserManagementEditRequest, options?: RequestInit): Promise<userManagementPartialUpdateResponse> => {

  return customFetch<userManagementPartialUpdateResponse>(getUserManagementPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedUserManagementEditRequest)
  }
);}


export type userManagementDestroyResponse200 = {
  data: AdminActionResponse
  status: 200
}

export type userManagementDestroyResponseSuccess = (userManagementDestroyResponse200) & {
  headers: Headers;
};
;

export type userManagementDestroyResponse = (userManagementDestroyResponseSuccess)

export const getUserManagementDestroyUrl = (id: string,) => {




  return `/api/v1/user-management/${id}/`
}

/**
 * DELETE /user-management/{id}/ — Deactivate user.
 */
export const userManagementDestroy = async (id: string, options?: RequestInit): Promise<userManagementDestroyResponse> => {

  return customFetch<userManagementDestroyResponse>(getUserManagementDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type userManagementChangeRoleCreateResponse200 = {
  data: UserManagementDetail
  status: 200
}

export type userManagementChangeRoleCreateResponseSuccess = (userManagementChangeRoleCreateResponse200) & {
  headers: Headers;
};
;

export type userManagementChangeRoleCreateResponse = (userManagementChangeRoleCreateResponseSuccess)

export const getUserManagementChangeRoleCreateUrl = (id: string,) => {




  return `/api/v1/user-management/${id}/change-role/`
}

/**
 * POST /user-management/{id}/change-role/ — Change user role.
 */
export const userManagementChangeRoleCreate = async (id: string,
    roleChangeRequest: RoleChangeRequest, options?: RequestInit): Promise<userManagementChangeRoleCreateResponse> => {

  return customFetch<userManagementChangeRoleCreateResponse>(getUserManagementChangeRoleCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(roleChangeRequest)
  }
);}


export type userManagementReactivateCreateResponse200 = {
  data: AdminActionResponse
  status: 200
}

export type userManagementReactivateCreateResponseSuccess = (userManagementReactivateCreateResponse200) & {
  headers: Headers;
};
;

export type userManagementReactivateCreateResponse = (userManagementReactivateCreateResponseSuccess)

export const getUserManagementReactivateCreateUrl = (id: string,) => {




  return `/api/v1/user-management/${id}/reactivate/`
}

/**
 * POST /user-management/{id}/reactivate/ — Reactivate user.
 */
export const userManagementReactivateCreate = async (id: string, options?: RequestInit): Promise<userManagementReactivateCreateResponse> => {

  return customFetch<userManagementReactivateCreateResponse>(getUserManagementReactivateCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type userManagementInviteCreateResponse201 = {
  data: UserManagementInviteSuccess
  status: 201
}

export type userManagementInviteCreateResponse400 = {
  data: UserManagementInviteError
  status: 400
}

export type userManagementInviteCreateResponse409 = {
  data: UserManagementInviteError
  status: 409
}

export type userManagementInviteCreateResponse500 = {
  data: UserManagementInviteError
  status: 500
}

export type userManagementInviteCreateResponseSuccess = (userManagementInviteCreateResponse201) & {
  headers: Headers;
};
export type userManagementInviteCreateResponseError = (userManagementInviteCreateResponse400 | userManagementInviteCreateResponse409 | userManagementInviteCreateResponse500) & {
  headers: Headers;
};

export type userManagementInviteCreateResponse = (userManagementInviteCreateResponseSuccess | userManagementInviteCreateResponseError)

export const getUserManagementInviteCreateUrl = () => {




  return `/api/v1/user-management/invite/`
}

/**
 * POST /user-management/invite/ — Invite a single user.
 */
export const userManagementInviteCreate = async (userManagementInviteRequest: UserManagementInviteRequest, options?: RequestInit): Promise<userManagementInviteCreateResponse> => {

  return customFetch<userManagementInviteCreateResponse>(getUserManagementInviteCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(userManagementInviteRequest)
  }
);}


export type userManagementScopeRetrieveResponse200 = {
  data: AdminScope
  status: 200
}

export type userManagementScopeRetrieveResponseSuccess = (userManagementScopeRetrieveResponse200) & {
  headers: Headers;
};
;

export type userManagementScopeRetrieveResponse = (userManagementScopeRetrieveResponseSuccess)

export const getUserManagementScopeRetrieveUrl = () => {




  return `/api/v1/user-management/scope/`
}

/**
 * GET /user-management/scope/ — Return admin's available scope data and permissions.
 */
export const userManagementScopeRetrieve = async ( options?: RequestInit): Promise<userManagementScopeRetrieveResponse> => {

  return customFetch<userManagementScopeRetrieveResponse>(getUserManagementScopeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


